import { ResourceModel } from '@/models';
import { ResourcePolicy } from '@/policies';
import { auth } from '@/services';

(function (angular) {
    'use strict';

    angular.module('app')
        .directive('resource', resource);

    resource.$inject = [
        '$rootScope',
        '$sce',
        'GroupsApi',
        'handleError',
        'Resources',
        'thisUser',
        'alerts',
        'thisSiteSettings'
    ];

    /**
     * Resource directive
     *
     * @return {Object}
     */
    function resource(
        $rootScope,
        $sce,
        GroupsApi,
        handleError,
        Resources,
        thisUser,
        alerts,
        thisSiteSettings
    ) {
        function resourceLink($scope) {
            const resourceModel = new ResourceModel($scope.resource);

            if (thisUser) {
                $scope.usersGroups = thisUser.groups.map(function(group) {return group.id});
            }
            
            // properties
            $scope.thisSiteSettings = thisSiteSettings;
            $scope.body = $sce.trustAsHtml($scope.resource.body);
            $scope.permissionChecks = {
                canManage: ResourcePolicy.canManage(auth.user(), resourceModel),
            };
            $scope.thisUser = $rootScope.thisUser;
            $scope.view = $scope.view || 'preview';
            // methods
            $scope.editResource = editResource;
            $scope.refreshResource = refreshResource;
            $scope.request = request;
            
            /**
             * Sends the connection request to the API
             * @return {void}
             */
            function request(groupId) {
                $scope.isLoadingMessage = 'Sending request...';
                $scope.isLoading = true;
                
                GroupsApi.GroupUserRequest(
                    { group_id: groupId },
                {
                    user_id: thisUser.id,
                    }, function handleRequesttResponse(response) {
                        $scope.isLoading = false;
                        $scope.resource.userRequested = true;
                
                        alerts.emit({
                            theme: 'success',
                            title: 'Request Sent',
                            messages: []
                        });
                }, function handleRequesttError() {
                    $scope.isLoading = false;
                        $scope.forceClose = true;
                    }
                );
            }

            /**
             * Edits the resource via a modal, and updates model
             * @param  {int} resourceId - ID of resource to edit
             * @return {void}
             */
            function editResource(resourceId) {
                Resources.manageResource(resourceId).then(refreshResource, handleError);
            }

            /**
             * Refreshes the on screen resource
             *
             * @param {object} resourceItem - The updated or deleted resource
             */
            function refreshResource(resourceItem) {
                if (resourceItem.deleted) {
                    $scope.onDelete(resourceItem);
                } else {
                    $scope.resource = resourceItem;
                }
            }

            function checkRequested() {
                $scope.resource.userRequested = false;

                if ($scope.resource.group && $scope.resource.group.user_requests.filter(o => o.user_id === thisUser.id).length > 0) {
                    $scope.resource.userRequested = true;
                }
            }
            checkRequested();
        }

        return {
            transclude: true,
            restrict: 'E',
            templateUrl: 'directives/resource.html',
            link: resourceLink,
            scope: {
                resource: '=',
                onDelete: '=?', // function to delete resource from parent scope
                view: '@', // "preview" or "full" (default: preview)
            },
        };
    }
}(angular));
